// extracted by mini-css-extract-plugin
export default {"popoverPaper":"SkipPart_popoverPaper__xETVv","popover":"SkipPart_popover__j0By7"};